<template>
  <v-container fluid>
    <header>
      <h1 class="title -tongue ml-5">
        Por favor verifique se os dados estão corretos
      </h1>
      <p class="grey--text">
        E clique no botão <strong>confirmar</strong> para gerar seu requerimento.
      </p>
    </header>

    <v-layout>
      <v-flex md6>

        <resume-entity/>

        <resume-mailing-address/>

        <resume-framework/>

        <resume-application-type/>

        <div class="mx-3 mt-3" v-if="!allValidSteps">
          Passo(s) incompleto(s)

          <v-card
            flat
            class="ml-3 px-4 py-2"
            color="grey lighten-5"
          >
            <ul class="px-1">
              <template v-for="(step, index) in validSteps">
                <li v-if="!step" :key="index">
                  Passo {{ index + 1 }}
                </li>
              </template>
            </ul>
          </v-card>
        </div>


        <v-checkbox
            class="px-3 py-2"
            v-model="truthInformation"
            label="Declaro que todas as informações são verdadeiras e completas."
        />
      </v-flex>

      <v-flex md4 offset-md1>

          <resume-payment-slip/>

        <resume-environmental-study-type-required/>
      </v-flex>

    </v-layout>

    <v-divider class="mt-5 mb-3"/>

    <v-flex xs6 offset-xs3>
      <v-layout justify-space-around>
        <v-btn
            flat
            @click="previousStep()">
          Voltar
        </v-btn>
        <v-btn
            large
            color="success"
            :disabled="!allValidSteps || !truthInformation"
            @click="createApplication()">
          <v-icon left>mdi-check-all</v-icon>
          Confirmar
        </v-btn>
      </v-layout>
    </v-flex>

  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import ResumeEntity from "./ResumeStep/ResumeEntity";
  import ResumeMailingAddress from "./ResumeStep/ResumeMailingAddress";
  import ResumeFramework from "./ResumeStep/ResumeFramework";
  import ResumeApplicationType from "./ResumeStep/ResumeApplicationType";
  import ResumePaymentSlip from "./ResumeStep/ResumePaymentSlip";
  import ResumeEnvironmentalStudyTypeRequired from "./ResumeStep/ResumeEnvironmentalStudyTypeRequired";

  export default {
    name: 'ResumeStep',
    components: {
      ResumeEntity,
      ResumeMailingAddress,
      ResumeFramework,
      ResumeApplicationType,
      ResumePaymentSlip,
      ResumeEnvironmentalStudyTypeRequired
    },
    data() {
      return {
        truthInformation: false,
      };
    },
    methods: {
      ...mapActions('newApplication', ['previousStep']),
      createApplication() {
        this.$emit('create-application', {});
      },
    },
    computed: {
      ...mapGetters('newApplication', ['validSteps']),
      allValidSteps() {
        return this.validSteps.every(Boolean);
      },
    }
  };
</script>
